import { render, staticRenderFns } from "./Arguments.vue?vue&type=template&id=6d15c858"
import script from "./Arguments.vue?vue&type=script&lang=js"
export * from "./Arguments.vue?vue&type=script&lang=js"
import style0 from "./Arguments.vue?vue&type=style&index=0&id=6d15c858&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports